import { Suspense, lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { RequireAuth } from '@/auth/RequireAuth';
import { AppShell } from '@/components/layout/AppShell';
import { LoginPage } from '@/pages/Login';
import { PwaBanners } from '@/pwa/PwaBanners';

/**
 * Route-level code splitting (task.md §6 performance): the entry bundle carries the login screen and the shell;
 * every page — and with it xlsx (Stock), jsbarcode / pdf.js / tesseract.js (Purchases) — loads on first visit.
 */
const SetupPage = lazy(() => import('@/pages/Setup').then((m) => ({ default: m.SetupPage })));
const DashboardPage = lazy(() => import('@/pages/Dashboard').then((m) => ({ default: m.DashboardPage })));
const SalesPage = lazy(() => import('@/pages/Sales').then((m) => ({ default: m.SalesPage })));
const DeliveriesPage = lazy(() => import('@/pages/Deliveries').then((m) => ({ default: m.DeliveriesPage })));
const PurchasesPage = lazy(() => import('@/pages/Purchases').then((m) => ({ default: m.PurchasesPage })));
const SuppliersPage = lazy(() => import('@/pages/Suppliers').then((m) => ({ default: m.SuppliersPage })));
const StockPage = lazy(() => import('@/pages/Stock').then((m) => ({ default: m.StockPage })));
const DebtsPage = lazy(() => import('@/pages/Debts').then((m) => ({ default: m.DebtsPage })));
const TasksPage = lazy(() => import('@/pages/Tasks').then((m) => ({ default: m.TasksPage })));
const WhatsAppPage = lazy(() => import('@/pages/WhatsApp').then((m) => ({ default: m.WhatsAppPage })));
const AttendancePage = lazy(() => import('@/pages/Attendance').then((m) => ({ default: m.AttendancePage })));
const ReportsPage = lazy(() => import('@/pages/Reports').then((m) => ({ default: m.ReportsPage })));
const SettingsPage = lazy(() => import('@/pages/Settings').then((m) => ({ default: m.SettingsPage })));

export function App() {
  return (
    <>
      <PwaBanners />
      <Suspense fallback={null}>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/setup" element={<SetupPage />} />
          <Route
            element={
              <RequireAuth>
                <AppShell />
              </RequireAuth>
            }
          >
            <Route path="/" element={<DashboardPage />} />
            <Route path="/sales" element={<SalesPage />} />
            <Route path="/purchases" element={<PurchasesPage />} />
            <Route path="/suppliers" element={<SuppliersPage />} />
            <Route path="/stock" element={<StockPage />} />
            <Route path="/debts" element={<DebtsPage />} />
            <Route path="/tasks" element={<TasksPage />} />
            <Route path="/tasks/:id" element={<TasksPage />} />
            <Route path="/whatsapp" element={<WhatsAppPage />} />
            <Route path="/attendance" element={<AttendancePage />} />
            <Route path="/reports" element={<ReportsPage />} />
            <Route path="/deliveries" element={<DeliveriesPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </Suspense>
    </>
  );
}
